var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.product)?_c('product-thumb',{key:_vm.product.handle,staticClass:"slice-product w-1x2 md_w-1x3 lg_w-1x4",attrs:{"doc":_vm.product,"images":_vm.product.images,"price":_vm.variant.price}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }